import apiWrapper from 'Helpers/apiWrapper'
import {
  type GetCountriesResponse,
  type GetRegionsByCountryCodeResponse,
} from 'Types/beGeolocationApi'

const endpoints = ((baseURL: string) => {
  return {
    getCountries: `${baseURL}/api/countries`,
    getRegionsByCountryCode: (countryCode: string) =>
      `${baseURL}/api/countries/${encodeURIComponent(countryCode)}/regions`,
  }
})(process.env.GEOLOCATION_API_URL as unknown as string)

export const beGeolocationApiGetCountries =
  async (): Promise<GetCountriesResponse> => {
    return await apiWrapper({
      method: 'get',
      url: endpoints.getCountries,
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => res.data)
  }

export const beGeolocationApiGetRegionsByCountryCode = async (
  countryCode: string,
): Promise<GetRegionsByCountryCodeResponse> => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.getRegionsByCountryCode(countryCode),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data)
}
